import React, { Fragment, memo, useContext, useEffect, useState } from "react";

import {
  AppContext,
  checkMobile,
  LOG_OUT_SUCCESS,
  MENU_SET_ALL,
  SET_ACNT_MRGE_LAYER,
  SET_APP_ALL,
  SET_NFTF_STATE,
  SET_USER_HEALTH,
  SocketCommand,
  socketManager,
} from "../components/AppProvider";

// Utils
import { _O } from "../modules/utils";

// Assets
import { Quick } from "../resources/Assets.Root";
import { Footer } from "./Footer";

import {
  PostApi154,
  PostApi1902,
  PostApi1910,
  PostApi1913,
  PostApi1970,
  PostApi960,
  PostApiCpnDn,
  PostApiCpnList,
  PostApiVideoInfo,
  postZoomSessionId,
} from "../modules/network/padoPost";
import {
  getCookie,
  getCookies,
  getCookieWs,
  lastLoginInfo,
  setCookie,
} from "../modules/utils/cookie";
import { closeLayerFn, MainContainer, openLayerFn } from "./Layout";
import { MyManagedSections } from "./Root.My.Managed";
// Temp Images
import _ARROW from "../resources/images/icon/icon_arrow_wp_down_min.png";
import _ARROW_UP from "../resources/images/icon/icon_arrow_wp_up_min.png";

import _LOGIN_ICON from "../resources/images/main/login_icon.svg";

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Layer } from "../components";
import {
  ConfirmLayer,
  CustomConfirmLayer,
  NewAlertLogout,
} from "../components/UI/Dialog";
import { GetGpsInfo } from "../modules/utils/GetGpsInfo";
import { NativeAction } from "../modules/utils/HandleWs";
import { userHabit } from "../modules/utils/UserHabit";
import { getAccessTokenApi } from "../modules/utils/ZoomApi";
import { IC } from "../resources/Assets";
import { autoLogin } from "./common/AutoLogin/AutoLogin";
import { HsptCnntTutorial } from "./common/Layer/HsptCnntTutorial";
import MdEduLayer from "./common/Layer/MdEduLayer";
import { ScrollToTop } from "./common/ScrollToTop/ScrollToTop";
import VideoPlayer from "./common/VideoLink/VideoPlayer";
import { loginLogInterface } from "./Membership/LoginOld";
import { webRequest } from "./Nftf/Interface/NFTF/NativeApi";
import MedicalCard from "./Nftf/MedicalCard/MedicalCard";
import useTitle from "./../modules/hooks/useTitle";

// eslint-disable-next-line import/no-anonymous-default-export
export default memo(props => {
  const {
    userinfo,
    mypagecfg,
    auth,
    cfg,
    phonecfg,
    dispatch,
    acntMergeLayer,
    nftfState,
  } = useContext(AppContext);
  const [loginInfo, setLoginInfo] = useState("");
  const [adList, setAdList] = useState();
  const [shareHspt, setShareHspt] = useState("");

  const [loginCnt, setLoginCnt] = useState(0);
  const [nftfData, setNftfData] = useState();
  const [getIdList, setGetIdList] = useState();

  const [nftfConnect, setNftfConnect] = useState(false);
  const [noticeAlarm, setNoticeAlarm] = useState(
    !getCookie("noticeAlarm") ? true : false
  );

  const [logoutView, setLogoutView] = useState(false);

  const [eventLayer, setEventLayer] = useState(false);

  // let ws = useRef(null);
  const setUserHlthInfo = (userinfo, cfg) => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;

          if (data.length > 0)
            dispatch({ type: MENU_SET_ALL, menutype: cardType, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result.sharHsptList.length > 0) {
            setShareHspt("Y");
          } else {
            setShareHspt("N");

            // 건너뛰기 한 경우
            if (getCookie("toDayNotAddHspt") != "Y") {
              openLayerFn($(".confirm-layer-hsptcnnt"));
              // _O.Open("/cnntHspt/9");
            }
          }
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
          if (data.setInfo.eduYn === "Y") {
            if (getCookie("viewEduLayer")) {
              if (new Date().getFullYear() != getCookie("viewEduLayer")) {
                // openLayerFn($("#mdEduLayer"));
              }
            } else {
              // openLayerFn($("#mdEduLayer"));
            }
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request960 = () => {
    PostApi960(phonecfg, cfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setAdList(res.resultList);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 81) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    } else if (phonecfg.phoneOS === "IOS") {
      if (parseInt(phonecfg.version.split(".")[2]) > 35) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    }
  }, []);

  const calcAge = birth => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = "0" + month;
    }

    if (day < 10) {
      day = "0" + day;
    }

    let monthDay = month + day;

    birth = birth.replace("-", "").replace("-", "");

    let birthdayy = birth.substr(0, 4);
    let birthdaymd = birth.substr(4, 4);
    let age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;

    return age;
  };

  const putJsonData = () => {
    // sex, age, height
    let sex = getCookie("sex") == "1" ? 0 : 1;
    let age = 20;
    let height = "170";

    if (getCookie("birth")) {
      age = calcAge(getCookie("birth"));
    }

    if (getCookie("hght")) {
      height = getCookie("hght");
    }
    return { sex: parseInt(sex), age: parseInt(age), height: parseInt(height) };
  };

  useEffect(() => {
    // openWebSocket();

    if (getCookie("birth")) {
      socketManager(SocketCommand.GET_BT_STATUS, undefined, putJsonData());
    }
  }, []);

  useEffect(() => {
    // 자동 로그인으로 재로그인 하는 경우
    if (getCookie("isAutologin")) {
      // 자동로그인은 사용하였지만 사용자 정보가 없는 경우
      if (!auth) {
        if (getCookie("userToken")) {
          if (phonecfg.phoneToken === "123" && phonecfg.version != "2.0.0") {
            if (
              !getCookie("phoneToken") ||
              getCookie("phoneToken") == "undefined"
            ) {
              openLayerFn($(".alert-layer-cnntFail"));
            } else {
              autoLogin(
                phonecfg,
                cfg,
                getCookies([
                  "userToken",
                  "userName",
                  "userEmail",
                  "userPhone",
                  "sex",
                  "birth",
                ]),
                dispatch,
                setUserHlthInfo,
                request1910,
                request1913
              );
              setLoginInfo(true);
            }
          } else {
            autoLogin(
              phonecfg,
              cfg,
              getCookies([
                "userToken",
                "userName",
                "userEmail",
                "userPhone",
                "sex",
                "birth",
              ]),
              dispatch,
              setUserHlthInfo,
              request1910,
              request1913
            );
            setLoginInfo(true);
          }
        } else {
          // 쿠키값을 못 가져왔을때 3번까지 재시도
          if (loginCnt < 3) {
            setLoginCnt(loginCnt + 1);
          } else {
            // openLayerFn($('.alert-layer-cnntFail'));
            openLayerFn($(".alert-layer-loginFail"));
            // 로그아웃 이후 재로그인 이동
          }
        }
      } else {
        // userInfoGenerator에서 사용자 정보를 세팅 한 후 넘어온 경우
        autoLogin(
          phonecfg,
          cfg,
          getCookies([
            "userToken",
            "userName",
            "userEmail",
            "userPhone",
            "sex",
            "birth",
          ]),
          dispatch,
          setUserHlthInfo,
          request1910,
          request1913
        );
        // request1913(userinfo);
      }
    } else {
      socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
        login: "out",
        userToken: "",
      });
      setShareHspt("");
      setLoginInfo(true);
    }
  }, [loginCnt]);

  useEffect(() => {
    request960();

    $(".map-view-layer .btn-closex").click(function () {
      closeLayerFn($(".map-view-layer"));
    });

    userHabit(phonecfg, "MH000");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, []);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({ title: "", msg: "" });

  const handleLogout = () => {
    $("#targetLogout").attr("id", "logoutSuccess");
    handleLogoutConfirm("확인", "로그아웃 하겠습니까?");
  };

  const handleLogoutConfirm = (title, msg) => {
    setDialog({ title: title, msg: msg });

    openLayerFn($("#confirm-layer"));
  };

  const handleLogoutCancelCB = () => {
    closeLayerFn($("#confirm-layer"));
  };

  const handleLogoutConfirmCB = () => {
    loginLogInterface(
      userinfo,
      phonecfg,
      cfg,
      "O",
      "M",
      getCookie("signUpChannel")
    );
    dispatch({ type: LOG_OUT_SUCCESS });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "out",
      userToken: "",
    });
    _O.Open("/membership/login");
    closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  // 비대면 접수 리스트 인터페이스
  const getNftfReceiptList = () => {
    PostApi1970(
      userinfo,
      cfg,
      phonecfg,
      props.match.params.seqNo ? props.match.params.seqNo : ""
    )
      .then(res => {
        if (res.resultMsg === "Success") {
          setNftfData(res.result);
        }
      })
      .catch(err => {
        console.log("err :: ", err);
      });
  };

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
    // getAccessTokenApi();
  }, []);

  useEffect(() => {
    window.sayHello = new CustomEvent("NativeEvent");
    const nativeEventCallback = event => {
      alert(`event receive from Native`);
    };

    window.addEventListener("NativeEvent", nativeEventCallback);

    // event listener clean up
    return () => {
      window.removeEventListener("NativeEvent", nativeEventCallback);
    };
  }, []);

  useEffect(() => {
    if (
      userinfo.userName != "" &&
      userinfo.userToken != "" &&
      userinfo.userToken != undefined &&
      userinfo.userToken &&
      userinfo.userToken != "undefined"
    ) {
      getMyAccount();
      getAllCoupon();
    }
  }, []);

  const location = useLocation();

  const getMyAccount = () => {
    PostApi154(
      phonecfg,
      cfg,
      userinfo.userName,
      userinfo.userPhone,
      userinfo.birth,
      userinfo.sex,
      getCookie("userDI"),
      "",
      ""
    )
      .then(res => {
        if (res.joinInfo.length > 1) {
          setGetIdList(res.joinInfo);
        }
      })
      .catch(err => {
        console.log("getMyAccount:: ", err);
      });
  };

  const getAllCoupon = () => {
    PostApiCpnList(userinfo, cfg, phonecfg, "TM")
      .then(res => {
        if (res.rsltCd === "E000") {
          setEventLayer(true);
          autoDownCoupon();
        }
      })
      .catch(err => {
        console.log("ERROR:: getAllCoupon");
      });
  };

  const autoDownCoupon = () => {
    PostApiCpnDn(userinfo, cfg, "TM")
      .then(res => {
        if (res.rsltCd === "E000") {
          // alert("다운로드 성공");
        } else {
          // alert("다운로드 실패");
        }
      })
      .catch(err => {
        console.log("ERROR:: autoDownCoupon");
      });
  };

  useEffect(() => {
    if (userinfo.userToken && userinfo.userToken != "") {
      getNftfReceiptList();
    }
  }, [location]);

  // 통합기능 임시 중단 2024-01-25
  useEffect(() => {
    if (getCookie("isAuthOk") && getCookie("isAuthOk").toString() == "0") {
      // if (acntMergeLayer) {
      if (!getCookie("acntMergeLayer")) {
        if (getIdList && getIdList.length > 1) {
          openLayerFn($("#cstmCnfmLayer"));
        }
      } else {
        getCookie("acntMergeLayer", true, 365);
      }
    }
  }, [getIdList]);

  const checkReceiptRoomOpen = () => {
    if (nftfData && nftfData.length > 0) {
      if (nftfData[0].telmdcnOpenYn === "Y") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const joinRoom = (seqNo, hsptCode, hsptName, telmdcnFrDh) => {
    PostApi1970(userinfo, cfg, phonecfg, seqNo)
      .then(res => {
        if (res.resultMsg === "Success") {
          setNftfData(res.result);
          if (res.result[0].zoomSessId != "") {
            postZoomSessionId(res.result[0].zoomSessId, cfg)
              .then(resSession => {
                if (
                  resSession &&
                  resSession.users &&
                  resSession.users.length > 0
                ) {
                  getAccessTokenApi(
                    hsptCode.toString(),
                    seqNo.toString(),
                    hsptName,
                    telmdcnFrDh,
                    userinfo,
                    phonecfg,
                    cfg
                  );
                } else {
                  alert("진료실에 입장한 의료진이 없습니다.");
                  setNftfConnect(false);
                }
              })
              .catch(err => {
                console.log("err :: ", err);
              });
          } else {
            alert("진료실에 입장한 의료진이 없습니다.");
            setNftfConnect(false);
          }
        }
      })
      .catch(err => {
        console.log(err);
        setNftfConnect(false);
      });
  };

  const [viewNotice0, setViewNotice0] = useState(true);

  const checkNotice0 = () => {
    sessionStorage.setItem("notice0", true);
    setViewNotice0(false);
  };

  useEffect(() => {
    webRequest("phoneInfo", {});
  }, []);

  useEffect(() => {
    if (nftfState.reload) {
      setNftfConnect(false);
      getNftfReceiptList();
      dispatch({
        type: SET_NFTF_STATE,
        data: {
          type: "RELOAD",
        },
      });
    }
  }, [nftfState.reload]);

  useTitle("홈_메인");

  return (
    <Fragment>
      <ScrollToTop />
      <MainContainer
        Title="케어포미"
        shareHspt={shareHspt}
        handleLogout={setLogoutView}
        setLoginCnt={setLoginCnt}
        floatButton={false}
        floatButtonOption={{
          severity: "primary",
          disable: "off",
          event: () => {
            joinRoom(
              nftfData[0].seqNo,
              nftfData[0].hsptCd,
              nftfData[0].hsptNm,
              nftfData[0].telmdcnFrDh
            );
          },
          text: "진료실 들어가기",
        }}>
        <div className="contents main">
          <div className="main-top-area">
            {auth ? (
              <Fragment>
                {userinfo.userName}님
                <br />
                건강관리에 함께 하겠습니다
              </Fragment>
            ) : (
              <Fragment>
                <div
                  style={{
                    display: "flex",
                    zIndex: "100",
                    position: "relative",
                  }}
                  onClick={() => _O.Open("/membership/login")}>
                  <div style={{ lineHeight: "28px" }}>로그인 후</div>
                  <div style={{ lineHeight: "28px", paddingLeft: "8px" }}>
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={_LOGIN_ICON}
                    />
                  </div>
                </div>
                의사와 함께 건강관리를 시작하세요
              </Fragment>
            )}
          </div>

          <QuickMenu />

          <div
            style={{
              padding: "0px 22px 11px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
            }}>
            {nftfData &&
              nftfData.length > 0 &&
              nftfData.map((data, i) => (
                <MedicalCard
                  // nftfData={nftfData[0]}
                  key={"MedicalCard" + i}
                  nftfData={data}
                  getNftfReceiptList={getNftfReceiptList}
                  nftfConnect={nftfConnect}
                  setNftfConnect={setNftfConnect}
                  setNftfData={setNftfData}
                />
              ))}
          </div>

          <MyManagedSections />

          {/* <CompanyInfo /> */}
          <Footer />
        </div>
      </MainContainer>
      {/* <MapView locationInfo={locationInfo} /> */}
      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleLogoutCancelCB}
        handleConfirmCB={handleLogoutConfirmCB}
      />

      <HsptCnntTutorial />
      {getIdList && (
        <CustomConfirmLayer
          priv="priv"
          title="계정통합안내"
          msg={
            "<div style='text-align:left'>" +
            userinfo.userName +
            "님은 " +
            getIdList.length +
            "개의 계정을 사용중입니다. <br /> 효율적인 건강관리를 위해 계정통합을 권장합니다. <br /> 계정을 통합하세요" +
            "</div>"
          }
          handleCancelCBText="닫기"
          handleCancelCB={() => {
            closeLayerFn($("#cstmCnfmLayer"));
            dispatch({ type: SET_ACNT_MRGE_LAYER, acntMergeLayer: false });
            setCookie("acntMergeLayer", true, 365);
          }}
          handleConfirmCBText="자세히 보기"
          handleConfirmCB={() => {
            _O.Open("/membership/acntMerge");
            dispatch({ type: SET_ACNT_MRGE_LAYER, acntMergeLayer: false });
            setCookie("acntMergeLayer", true, 365);
          }}
        />
      )}

      {eventLayer && (
        <Layer
          title={"비대면 서비스 이용료 \n 할인쿠폰이 발급되었습니다"}
          desc={
            "비대면 서비스 이용료 할인쿠폰을 증정해드립니다. \n 쿠폰은 비대면진료 예약시 자동으로 사용됩니다."
          }
          ps=""
          button={[
            {
              severity: "light",
              disable: "off",
              size: "large",
              clickEvent: e => {
                setEventLayer(false);
              },
              text: "더이상 보지않기",
            },
            {
              severity: "primary",
              disable: "off",
              size: "large",
              clickEvent: () => {
                _O.Open("/mp/couponList");
              },
              text: "쿠폰함 이동하기",
            },
          ]}
        />
      )}
      {/* {phonecfg.phoneOS === "IOS" &&
        !sessionStorage.getItem("notice0") &&
        viewNotice0 && (
          <Layer
            title={["[케어포미 서비스 안내]"]}
            desc={[
              "케어포미 iOS 버전 서비스 앱스토어 심사지연으로 인해 일부 기능 사용이 정상적이지 않을 수 있습니다.",
              <br />,
              <br />,
              "▷ 점검일시 2024년 12월 26일(목) 오전 8시 부터 ~",
              <br />,
              "▷ 이용불가 서비스 :",
              <br />,
              "  1. 비대면진료 예약",
              <br />,
              "  2. 전자처방전 관련 기능",
              <br />,
              "  3. 교육자료 확인, 전송",
              <br />,
              "  4. 혈압/혈당 입력",
              <br />,
              <br />,
              "서비스 이용에 불편을 드려 죄송합니다. 현재 최대한 빠른 정상화를 위해 노력하고 있습니다.",
              <br />,
              "편리하고 안전한 서비스를 위해 노력하는 미라벨소프트가 되겠습니다. 감사합니다.",
            ]}
            ps=""
            button={[
              {
                severity: "primary",
                disable: "off",
                size: "large",
                clickEvent: () => {
                  checkNotice0();
                },
                text: "확인",
              },
            ]}
          />
        )} */}

      <MdEduLayer />
      <NewAlertLogout logoutView={logoutView} setLogoutView={setLogoutView} />
    </Fragment>
  );
});

const _QUICKMENU = [
  {
    label: "병원/비대면예약",
    url: "/surround",
    ret: 5,
  },
  {
    label: "개인진료기록",
    url: "/pmr/treatmentData",
    ret: 0,
  },
  {
    label: "자가건강관리",
    url: "/sm",
    ret: 4,
  },
  {
    label: "처방전",
    url: "/eocs",
    ret: 4,
  },
  {
    label: "제증명서류",
    url: "/pmr/proofRecipt",
    ret: 7,
  },
  {
    label: "검사스케쥴",
    url: "/schedule",
    ret: 9,
  },
];

const QuickMenu = props => {
  const { auth, userinfo, phonecfg } = useContext(AppContext);

  const onClickMenu = (url, ret) => {
    if (url.length > 0) {
      if (!auth) {
        if (ret > 0) {
          _O.OpenMenu("/membership/login/" + ret + "/");
        } else {
          _O.OpenMenu("/membership/login");
        }
      } else {
        if (ret === 9) {
          _O.OpenMenu(url);
        } else {
          if (ret === 7) {
            if (getCookie("introAge") == "true") {
              // _O.OpenMenu("/proof/apply");
              _O.OpenMenu("/pmr/proofRecipt");
            } else {
              _O.OpenMenu(url);
            }
          } else {
            _O.OpenMenu(url);
          }
        }
      }
    } else {
      getCookieWs(lastLoginInfo);
    }
  };

  return (
    <div
      className="quick-menu-box"
      style={{
        padding: "0px 22px 11px 22px",
      }}>
      <ul>
        {_QUICKMENU.map((menu, i) => (
          <li key={i}>
            <a onClick={() => onClickMenu(menu.url, menu.ret)}>
              <div>
                <img src={Quick[i]} alt={menu.label} />
                <p>{menu.label}</p>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const SlideBanner = props => {
  const { adList } = props;
  const { cfg } = useContext(AppContext);
  useEffect(() => {
    //슬라이드 스크립트
    $(".banner-slide").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: true,
    });
  }, []);

  // socketManager(SocketCommand.MD_EDUCO_CONNECT, reloadList, putJsonData());
  return (
    <div className="main-bot-banner">
      <div className="banner-slide">
        <SlideVideo />{" "}
        {/* {adList && adList.map((m,i) => (
                    <Fragment>
                        <SlideImage key={"adList"+i} m={m} />
                    </Fragment>
                ))} */}
      </div>
    </div>
  );
};

const SlideVideo = props => {
  const { m } = props;
  const { cfg } = useContext(AppContext);
  const [adList, setAdList] = useState();

  const requestVideoInfo = (vdeoId, vdeoType, vdeoDtlType) => {
    PostApiVideoInfo(cfg, vdeoId, vdeoType, vdeoDtlType)
      .then(res => {
        // vdeoId 없으면 광고 안나옴 vdeoSrcType = S:스트리밍 B:배너 embdType = D:div I:iframe
        if (res.resultMsg === "SUCC") {
          setAdList(res.vdeoInfo);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    requestVideoInfo(1, "AD", "M");
  }, []);

  return (
    <div>
      {adList && (
        <VideoPlayer
          videoStyle={{
            width: "100%",
            height: "100%",
          }}
          videoId={adList.srcUrl}
          // thumbNail={adList.thmnUrl}
          thumbNail={IC.etc.AD1_THUMNAIL}
        />
      )}
    </div>
  );
};

const SlideImage = props => {
  const { m } = props;
  const { cfg } = useContext(AppContext);
  return (
    <div>
      <a onClick={() => _O.Open(m.linkURL)}>
        <img src={cfg.faxUrl + m.imgURL} alt="" />
      </a>
    </div>
  );
};

const CompanyInfo = () => {
  const [openState, setOpenState] = useState(false);

  const openCompanyInfo = () => {
    if (openState === true) {
      setOpenState(false);
    } else {
      setOpenState(true);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    }
  };

  return (
    <Fragment>
      <div onClick={openCompanyInfo}>
        <p
          style={{
            textAlign: "center",
            fontSize: "12px",
            color: "#809FFF",
          }}>
          사업자 정보 확인하기
        </p>
        <p
          style={{
            textAlign: "center",
            paddingBottom: "12px",
          }}>
          <img
            src={openState === false ? _ARROW : _ARROW_UP}
            style={{
              width: "15px",
              paddingLeft: "7px",
            }}
          />
        </p>
      </div>

      {openState === true && (
        <div
          id="companyInfoBox"
          style={{
            paddingBottom: "12px",
            fontSize: "12px",
            textAlign: "center",
          }}>
          <div>
            <p style={{ color: "#809FFF" }}>(주)미라벨소프트</p>
            <p style={{ color: "#809FFF" }}>
              사업자등록번호:535-88-01537 | 대표자:박기호
            </p>
            <p style={{ color: "#809FFF" }}>
              통신판매업신고:제2022-서울서초-0002호
            </p>
            <p style={{ color: "#809FFF" }}>
              주소:서울특별시 서초구 효령로 304 국제전자센터 11층 11054호
            </p>
            <p style={{ color: "#809FFF" }}>이메일:mirabellsoft@mdpark.co.kr</p>
            <p style={{ color: "#809FFF" }}>대표번호:1877-4872</p>
            <p style={{ color: "#809FFF" }}>ⓒ 2021 (주)미라벨소프트</p>
          </div>
        </div>
      )}
    </Fragment>
  );
};
